import { render, staticRenderFns } from "./loading-spinner.vue?vue&type=template&id=22925df2&scoped=true&"
import script from "./loading-spinner.vue?vue&type=script&lang=js&"
export * from "./loading-spinner.vue?vue&type=script&lang=js&"
import style0 from "./loading-spinner.vue?vue&type=style&index=0&id=22925df2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22925df2",
  null
  
)

export default component.exports